import {useTranslation} from '../../../hooks/useTranslation'

export function usePassAccessLabels() {
    const {t} = useTranslation()
    return {
        group: t('client.passes.access.group'),
        individual: t('client.passes.access.individual'),
        all: t('client.passes.access.all'),
        selected: (count: number) => t('client.passes.access.selected', {count}),
    }
}
